import { Box, Stack } from "@mui/material";

export default function ThumbnailField({ src }) {
  return (
    <Stack
      direction="column"
      spacing={0.5}
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%", height: "100%" }}
    >
      <Box
        sx={{
          border: "1px solid #0000003B",
          width: "fit-content",
          display: "flex",
        }}
      >
        <img
          src={src}
          alt="thumbnail"
          style={{
            width: "40px",
            height: "40px",
          }}
        />
      </Box>
    </Stack>
  );
}
